import { apiClient } from "../api/AllApi";
import i18nModule, { normalizeLang } from "../../i18";

const { i18n } = i18nModule;

let cachedMeta = null;
let loadPromise = null;

/** @deprecated kept empty — edits now write real locale JSON files */
export function applyLocaleOverrides() {
  /* no-op: no runtime overlay */
}

export async function ensureLocaleBundle(locale) {
  const code = normalizeLang(locale);
  try {
    await i18n.loadLanguages(code);
  } catch { /* ignore */ }
  return code;
}

export async function applyOverridesForLocale(locale) {
  return ensureLocaleBundle(locale);
}

/**
 * Prefetch translation editor meta (and migrate any legacy DB overlays on the server).
 * Does not layer a runtime override bag anymore.
 */
export async function loadTranslationOverrides({ force = false } = {}) {
  if (!force && cachedMeta) return cachedMeta.overrides || {};
  if (!force && loadPromise) return loadPromise;

  loadPromise = apiClient
    .get("/settings/translations", { skipForbiddenToast: true })
    .then((res) => {
      cachedMeta = res.data || {};
      // Empty map — files are the source of truth now.
      return cachedMeta.overrides || { en: {}, ku: {}, ar: {}, tr: {} };
    })
    .catch(() => {
      cachedMeta = cachedMeta || { overrides: {} };
      return cachedMeta.overrides || {};
    })
    .finally(() => {
      loadPromise = null;
    });

  return loadPromise;
}

/**
 * Patch keys in the real public/locales/{locale}/translation.json via API,
 * then reload that locale into i18next from the file.
 */
export async function saveTranslationOverrides(locale, changes) {
  const code = normalizeLang(locale);
  const res = await apiClient.put("/settings/translations", { locale: code, changes });
  const translations = res.data?.translations;

  try {
    await i18n.reloadResources([code], ["translation"]);
  } catch { /* ignore */ }

  // If the browser still has a cached JSON response, inject the saved bag.
  if (translations && typeof translations === "object") {
    i18n.addResourceBundle(code, "translation", translations, true, true);
  }

  if (normalizeLang(i18n.language) === code) {
    await i18n.changeLanguage(code);
  }

  cachedMeta = {
    ...(cachedMeta || {}),
    overrides: { ...((cachedMeta && cachedMeta.overrides) || {}), [code]: {} },
  };

  // Return empty override bag (UI treats file as the value source).
  return {};
}

export function getCachedOverrides() {
  return (cachedMeta && cachedMeta.overrides) || {};
}

export function getTranslationMeta() {
  return cachedMeta;
}
